import React from "react";
import PanelNav from "../Components/Panel/PanelNav";
import Depositpage from "../Components/Panel/Depositpage";
import Layout from "./Layout";

export default function Panel() {
  return (
    <Layout>
      <section className="h-4/6 xs:h-4/6 mx-auto max-w-screen-xl px-4 grid grid-cols-1 lg:grid-cols-6 xl:grid-cols-5 w-full my-6">
        <PanelNav />
        <Depositpage />
      </section>
    </Layout>
  );
}
